/* Retrofuture Earthfall world layer. Lightweight global behaviours only.
   This file never changes window.location or the active Shopify preview route. */
(function () {
  'use strict';

  if (window.RFEarthfallWorld) return;

  var revealObserver = null;

  function initReveals(scope) {
    var root = scope || document;
    var targets = Array.prototype.slice.call(root.querySelectorAll('[data-rf-world-reveal]:not(.is-visible)'));
    if (!targets.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (target) {
        target.classList.add('is-visible');
      });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.08
      });
    }

    targets.forEach(function (target) {
      revealObserver.observe(target);
    });
  }

  function scan(scope) {
    initReveals(scope);
  }

  function boot() {
    scan(document);
  }

  window.RFEarthfallWorld = {
    scan: scan
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
